import { render } from "./LobbyX.vue?vue&type=template&id=6a961be6&scoped=true"
import script from "./LobbyX.vue?vue&type=script&lang=js"
export * from "./LobbyX.vue?vue&type=script&lang=js"

import "./LobbyX.vue?vue&type=style&index=0&id=6a961be6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a961be6"

export default script